import React, { Fragment, useEffect, useMemo } from 'react';
import { useSortBy } from 'react-instantsearch-hooks-web';
import { useSearchStateIndex } from './hooks/useSearchStateIndex';
import { Menu, Transition } from '@headlessui/react';
import IconCaret from '../ui/icons/IconCaret';
import config from './config/config';
import { useMobileMediaQuery } from './hooks/useResponsive';

function SearchSort( ) {
	const { activeIndexName } = useSearchStateIndex();
	const isMobile = useMobileMediaQuery();
	const { currentRefinement, options, refine } = useSortBy( {
		items: [
			{ label: 'Featured', value: activeIndexName },
			{ label: 'Price: Low to High', value: `${ activeIndexName }_price_asc` },
			{ label: 'Square Feet', value: `${ activeIndexName }_square_footage_asc` },
			{ label: 'Date Available', value: `${ activeIndexName }_move_in_date_asc` },
			{ label: 'Newest', value: `${ activeIndexName }_date_added_desc` },
			{ label: 'Bedrooms', value: `${ activeIndexName }_beds_asc` },
			{ label: 'Bathrooms', value: `${ activeIndexName }_bathrooms_asc` },
		],
	} );

	// update index when index tabs are toggled
	useEffect( () => {
		if ( currentRefinement.includes( activeIndexName ) ) {
			return;
		}

		const oldIndexName = currentRefinement.includes( config.ALGOLIA_INDEX_DEFAULT ) ? config.ALGOLIA_INDEX_DEFAULT : config.ALGOLIA_INDEX_HOMES;
		const newIndexName = activeIndexName.includes( config.ALGOLIA_INDEX_DEFAULT ) ? config.ALGOLIA_INDEX_DEFAULT : config.ALGOLIA_INDEX_HOMES;
		const newIndex = currentRefinement.replace( oldIndexName, newIndexName );
		refine( newIndex );
	}, [ activeIndexName, currentRefinement, refine ] );

	const currentLabel = useMemo( () => {
		const currentOption = options.find( ( { value } ) => value === currentRefinement );
		const label = currentOption ? currentOption.label : '';
		if ( ! isMobile ) {
			return label;
		}
		if ( label.length > 11 ) {
			return label.slice( 0, 11 ) + '...';
		}
		return label;
	}, [ currentRefinement, options, isMobile ] );

	return (
		<div className="tw-text-right tw-flex tw-items-center tw-justify-end">
			<Menu as="div" className="tw-relative tw-inline-block tw-text-left tw-z-10">
				{( { open } ) => (
					<>
						<div>
							<Menu.Button className="hover:tw-text-slate tw-flex tw-items-center tw-w-full tw-text-base tw-bg-transparent">
								<span className='tw-hidden tw-font-normal tw-flex-nowrap xl:tw-flex tw-whitespace-nowrap'>Sort by: </span>
								<span className='tw-font-medium tw-ml-1 tw-text-charcoal'>{currentLabel}</span>
								<span className={`${ open ? 'tw-rotate-180' : '' } tw-transition-all tw-ml-2`}>
									<IconCaret fill={'charcoal'} />
								</span>
							</Menu.Button>
						</div>
						<Transition
							as={Fragment}
							enter="tw-transition tw-ease-out tw-duration-100"
							enterFrom="tw-transform tw-opacity-0"
							enterTo="tw-transform tw-opacity-100"
							leave="tw-transition tw-ease-in tw-duration-75"
							leaveFrom="tw-transform tw-opacity-100"
							leaveTo="tw-transform tw-opacity-0"
						>
							<Menu.Items className="tw-absolute tw-right-0 tw-w-56 tw-mt-2 tw-origin-top-right tw-bg-white tw-shadow tw-z-10">
								<div className="px-1 py-1 ">
									{options.map( ( { label, value } ) => {
										const isActive = currentRefinement === value;
										return (
											<Menu.Item>
												<button
													className={`${
														isActive ? 'tw-font-medium' : 'tw-font-normal'
													} tw-group tw-flex tw-w-full tw-items-center tw-rounded-md tw-px-2 tw-py-2 tw-text-base tw-text-charcoal tw-bg-white hover:tw-text-slate`}
													onClick={() => refine( value )}
												>
													{label}
												</button>
											</Menu.Item>
										);
									} )}
								</div>
							</Menu.Items>
						</Transition>
					</>
				)}
			</Menu>
		</div>
	);
}

export default SearchSort;
